import {
    DEFAULT_PAGE_SIZE,
    FAILED_LOGIN_COUNTRIES_SORT_BY,
    FAILED_LOGIN_COUNTRIES_TABLE_COLUMNS,
} from '@common/constants';
import { OrderBy } from '@common/types';
import { TableWrapper } from '@components/partials';

import { PeopleSortBy } from '@hooks/people/types';
import { useFailedLoginDataCountriesPreviewQuery } from '@hooks/security';
import { usePagination } from '@hooks/utils/pagination';

import { formatDate, useTableData } from '@utils/index';
import React, { useState } from 'react';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';
import { API_ENDPOINTS } from '@api/ApiEndpoints';
import useDownloadCsvSafe from '@hooks/utils/export/useDownloadCsvSafe';
import { createCellValue } from '../utils';
import { useLocation } from 'react-router-dom';

const pageSize = DEFAULT_PAGE_SIZE;

const FailedLoginCountriesPage: React.FC = () => {
    const days = new URLSearchParams(useLocation().search).get("days") || "30";
    const [search, setSearch] = useState('');
    const { pageNumber, setPageNumber } = usePagination();
    const [queryParams, setQueryParams] = useQueryParams({
        search: withDefault(StringParam, ''),
        sortBy: withDefault(StringParam, 'failedlogins'),
        order: withDefault(StringParam, 'desc'),
    });

    // table
    const query = useFailedLoginDataCountriesPreviewQuery({
        pageSize,
        pageNumber,
        searchTerm: search,
        sortBy: queryParams.sortBy as PeopleSortBy,
        order: queryParams.order as OrderBy,
        days,
    });

    const getTableData = useTableData(
        query,
        FAILED_LOGIN_COUNTRIES_TABLE_COLUMNS,
        createCellValue
    );

    const { handleDownloadClick } = useDownloadCsvSafe({
        endpoint: `${API_ENDPOINTS.FAILED_LOGIN_DATA_COUNTRIES_EXPORT}`,
        params: {
            pageSize,
            pageNumber,
            searchTerm: search,
            sortBy: queryParams.sortBy as PeopleSortBy,
            order: queryParams.order as OrderBy,
            days,
        },
        filename: `Clevr360_Faled_login_data_${formatDate(
            new Date().toString()
        )}.csv`,
    });


    return (
        <div className="mt-2">
            <TableWrapper
                testId='failed-login-countries-table'
                search={search}
                setSearch={setSearch}
                searchPlaceholder={'Search by country name'}
                columns={FAILED_LOGIN_COUNTRIES_TABLE_COLUMNS}
                data={getTableData()}
                sortData={FAILED_LOGIN_COUNTRIES_SORT_BY}
                searchKey="search"
                query={query}
                refetchQuery={query.refetch}
                queryParams={queryParams}
                setQueryParams={setQueryParams}
                setPageNumber={setPageNumber}
                isCollapsable={true}
                sliceColumns={1}
                floatingFilterButton={false}
                hasFilterBanner={false}
    
                searchCountStatsLabel="countries"
                isDownloadAvailable={true}
                handleDownload={handleDownloadClick}
                noResultTitle={search ? 'No results matching your search' 
                    : 'There are no accounts with failed logins identified on your Microsoft 365 service'}
                  noResultSubtitle={search ? 'Try a less specific search.' : ''}
            />
        </div>
    );
};

export default FailedLoginCountriesPage;
